export enum Country {
  Belarus = 'BY',
}